module.exports = __webpack_public_path__ + "media/images/emoticons/upwardleft-bf7ac492d0e1f37c40d107f276f03836.gif";